import React, { Component, useState } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { AlmacenForm } from "./components/AlmacenForm";
import "./CreacionTrasladoAlmacen.css";

class CreacionTrasladoAlmacen extends Component {
    state = {
        almacenId: null,
    };

    componentWillMount() {
        this.setState({ almacenId: this.props.match.params.id });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        const { user, configuraciones } = this.props;

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="right-arrow-v2"
                    titulo="Trasladar entre almacenes"
                    subtitulo=""
                    col="12"
                >
                    <AlmacenForm
                        almacenId={this.state.almacenId}
                        regresar={this.regresar}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const user = state.login.me;

    return {
        user,
    };
};

export default connect(mstp, {})(CreacionTrasladoAlmacen);
